"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
const moment_1 = __importDefault(require("moment"));
const core_1 = require("@angular/core");
const vehicle_1 = require("../../shared/models/vehicle/vehicle");
const enums_1 = require("../../@shared-types/vehicle/enums");
const users_service_1 = require("../../../../shared/users/users.service");
const abstract_analysis_component_1 = __importDefault(require("../abstract/abstract-analysis.component"));
var SalesChartData;
(function (SalesChartData) {
    SalesChartData["SELLER"] = "seller";
    SalesChartData["MAKE"] = "make";
    SalesChartData["MODEL"] = "model";
})(SalesChartData || (SalesChartData = {}));
var SalesTableData;
(function (SalesTableData) {
    SalesTableData["ID"] = "vehicleId";
    SalesTableData["VIN"] = "vin";
    SalesTableData["CUSTOMER"] = "customerId";
    SalesTableData["INVENTORY_STATE"] = "inventoryState";
    SalesTableData["PLANNED_HANDOVER"] = "plannedHandover";
})(SalesTableData || (SalesTableData = {}));
let SalesAnalysisComponent = class SalesAnalysisComponent extends abstract_analysis_component_1.default {
    constructor(vehicle, usersService) {
        super();
        this.vehicle = vehicle;
        this.usersService = usersService;
        this.chartTitle = 'Verkaufte Fahrzeuge';
        this.mode = 'SUM';
        this.p = 1;
        this.getData = () => __awaiter(this, void 0, void 0, function* () {
            const vehicles = yield this.vehicle.getAll({ 'vehicleData.availability.code': enums_1.EAvailabilityCode.Sold });
            const chartData = [];
            const tableData = [];
            // Convert data to custom type
            vehicles.forEach((v) => {
                var _a, _b, _c, _d;
                if (!v.vehicleData.availability.sellData
                    || !(0, moment_1.default)(v.vehicleData.availability.sellData.contractDate).isValid())
                    return;
                const seller = this.usersService.getNameOfUser(v.vehicleData.availability.sellData.seller || 0, '(Ohne Verkäufer)');
                chartData.push({
                    [SalesChartData.SELLER]: seller,
                    [SalesChartData.MAKE]: ((_a = v.modelData) === null || _a === void 0 ? void 0 : _a.make) || '(Ohne Marke)',
                    [SalesChartData.MODEL]: ((_b = v.modelData) === null || _b === void 0 ? void 0 : _b.model) || '(Ohne Modell)',
                    date: (0, moment_1.default)(v.vehicleData.availability.sellData.contractDate).toDate(),
                });
                tableData.push({
                    vehicleId: String(v._id),
                    date: v.vehicleData.availability.sellData.contractDate,
                    customerId: v.vehicleData.availability.sellData.customerId,
                    make: ((_c = v.modelData) === null || _c === void 0 ? void 0 : _c.make) || '(Ohne Marke)',
                    model: ((_d = v.modelData) === null || _d === void 0 ? void 0 : _d.model) || '(Ohne Modell)',
                    seller,
                    vin: v.vin || 'Keine Fahrgestellnummer',
                    inventoryState: String(v.vehicleData.inventory.state || ''),
                    plannedHandover: !v.vehicleData.availability.sellData.plannedHandover ? '(Nicht angegeben)' : (0, moment_1.default)(v.vehicleData.availability.sellData.plannedHandover).format('DD.MM.YYYY'),
                });
            });
            return { chart: chartData, table: tableData };
        });
        this.filter = {
            filterOptions: {
                seller: [],
                make: [],
                model: [],
            },
            filterValues: {
                seller: [],
                make: [],
                model: [],
            },
            filterTranslations: {
                seller: 'Verkäufer',
                make: 'Marke',
                model: 'Modell',
            },
            filterGroup: SalesChartData.MAKE,
            yearOptions: [],
            yearValue: (0, moment_1.default)().format('YYYY'),
        };
        this.chartTitle = 'Verkaufte Fahrzeuge';
    }
};
SalesAnalysisComponent = __decorate([
    (0, core_1.Component)({
        selector: 'sales-analysis',
        templateUrl: require('./sales-analysis.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _a : Object, typeof (_b = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _b : Object])
], SalesAnalysisComponent);
exports.default = SalesAnalysisComponent;
